// extracted by mini-css-extract-plugin
export var skipAnimation = "_3k-0";